import { useEffect, useMemo, useState } from 'react';
import { getPistasJornada, getPistasPublicadas } from '../services/asignacionPistaService';

// Hora y pista de cada partido: { [partidoId]: { pista, hora } }. En el lado
// público solo cuentan las jornadas que el ADMIN ha publicado; en /dashboard,
// el reparto aunque sea un borrador. Si falla una jornada, simplemente no
// se muestra su pista (la pantalla de jornadas no depende de esto).
export function usePistasPartidos(temporada, jornadas, publico) {
  const [porPartido, setPorPartido] = useState({});
  const clave = jornadas.join(',');

  useEffect(() => {
    if (!temporada || !clave) {
      setPorPartido({});
      return undefined;
    }
    let cancelado = false;
    const pedir = publico ? getPistasPublicadas : getPistasJornada;
    Promise.all(clave.split(',').map((j) => pedir(temporada, Number(j)).catch(() => null)))
      .then((respuestas) => {
        if (cancelado) return;
        const mapa = {};
        respuestas.forEach((r) => (r?.partidos || []).forEach((p) => {
          if (p.pista && p.hora_inicio) mapa[p.id] = { pista: p.pista, hora: p.hora_inicio.slice(0, 5) };
        }));
        setPorPartido(mapa);
      });
    return () => { cancelado = true; };
  }, [temporada, clave, publico]);

  return useMemo(() => porPartido, [porPartido]);
}
